__turbopack_context__.v({
  "createAccount": "sign-in-module-scss-module__J6H6XW__createAccount",
  "hairline": "sign-in-module-scss-module__J6H6XW__hairline",
  "loginContainer": "sign-in-module-scss-module__J6H6XW__loginContainer",
  "loginForm": "sign-in-module-scss-module__J6H6XW__loginForm",
  "loginPicture": "sign-in-module-scss-module__J6H6XW__loginPicture",
  "logo": "sign-in-module-scss-module__J6H6XW__logo",
});
